import {
  H3_PROJECT_IMG02,
  H3_PROJECT_IMG03,
  H3_PROJECT_IMG04,
  H5_PROJECT_IMG01,
  H5_PROJECT_IMG02,
  H5_PROJECT_IMG03,
  H5_PROJECT_IMG04,
  H5_PROJECT_IMG05,
  PROJECT_IMG01,
  PROJECT_IMG02,
  PROJECT_IMG03,
} from "../lib/assets";
import projectImg01 from "../assets/img/project/complete_project_03.png";
import projectImg02 from "../assets/img/project/complete_project_02.png";
import projectImg03 from "../assets/img/project/complete_project_01.png";

export const PROJECT_LIST_TWO = [
  {
    id: 1,
    img: projectImg01,
    href: "/project-details",
    title: "Paying personal bills from the business account",
    tag: "Groceries and family meals aren't business expenses",
  },
  {
    id: 2,
    img: projectImg02,
    href: "/project-details",
    title: "Not keeping receipts",
    tag: "The CRA expects records kept for at least 6 years",
  },
  {
    id: 3,
    img: projectImg03,
    href: "/project-details",
    title: "Leaving bookkeeping until tax time",
    tag: "A year of catch-up costs more than monthly books",
  },
];

export const PROJECT_LIST_THREE = [
  {
    id: 1,
    href: "/project-details",
    src: H3_PROJECT_IMG02,
  },
  {
    id: 2,
    href: "/project-details",
    src: H3_PROJECT_IMG02,
  },
  {
    id: 3,
    href: "/project-details",
    src: H3_PROJECT_IMG03,
  },
  {
    id: 4,
    href: "/project-details",
    src: H3_PROJECT_IMG04,
  },
];

export const PROJECT_LIST_FOUR = [
  {
    id: 1,
    href: "/project-details",
    src: H5_PROJECT_IMG01,
    title: "Illustration Design",
    subtitle: "Creative Work",
  },
  {
    id: 2,
    href: "/project-details",
    src: H5_PROJECT_IMG02,
    title: "Design & Development",
    subtitle: "Planing",
  },
  {
    id: 3,
    href: "/project-details",
    src: H5_PROJECT_IMG03,
    title: "Marketing Consultancy",
    subtitle: "Development",
  },
  {
    id: 4,
    href: "/project-details",
    src: H5_PROJECT_IMG04,
    title: "Digital Marketing",
    subtitle: "Skill Development",
  },
  {
    id: 5,
    href: "/project-details",
    src: H5_PROJECT_IMG05,
    title: "Strategic Planning",
    subtitle: "Marketing",
  },
];

export const PROJECT_LIST_ONE = [
  {
    id: 1,
    href: "/project-details",
    tag: "Achievment",
    tagHref: "/project",
    src: PROJECT_IMG01,
    title: "Based on your Correct situation",
  },
  {
    id: 2,
    href: "/project-details",
    tag: "Business Strategy",
    tagHref: "/project",
    src: PROJECT_IMG02,
    title: "Best mortgage rates guaranteed.",
  },
  {
    id: 3,
    href: "/project-details",
    tag: "Investment",
    tagHref: "/project",
    src: PROJECT_IMG03,
    title: "Investment Policy For New Project",
  },
  {
    id: 4,
    href: "/project-details",
    tag: "Achievment",
    tagHref: "/project",
    src: PROJECT_IMG01,
    title: "Based on your Correct situation",
  },
];
